import Vue from 'vue'
import Vuex from 'vuex'
import ChartCategory from './modules/ChartCategory'
import Notification from './modules/Notification'
import BulkUpdateFields from './modules/BulkUpdateFields'
import BulkUpdateFeedbackModule from './modules/BulkUpdateFeedbackModule'
import FormTranslation from './modules/FormTranslation'
import FormStatus from './modules/FormStatus'
import SustainabilityData from './modules/SustainabilityData'
import Visualizations from './modules/Visualizations'
import WalkthroughAttachments from './modules/WalkthroughAttachments'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    ChartCategory,
    Notification,
    BulkUpdateFields,
    BulkUpdateFeedbackModule,
    FormTranslation,
    FormStatus,
    SustainabilityData,
    Visualizations,
    WalkthroughAttachments,
  },
})
